module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-main"
  }, [_c('div', {
    staticClass: "footer-main__content"
  }, [_c('div', {
    staticClass: "footer-main__content-main"
  }, [_c('div', {
    staticClass: "footer-main__loc"
  }, [_c('div', {
    staticClass: "footer-main__title"
  }, [_vm._v("Boone Location")]), _c('div', {
    staticClass: "footer-main__info"
  }, [_c('a', {
    staticClass: "footer-main__addy",
    attrs: {
      "href": "https://goo.gl/maps/2p8qpsBWqd92",
      "target": "_blank",
      "title": "Google Map"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "footer-pin",
      "aria-label": "Google Map"
    }
  }), _vm._v("373 Boone Heights Drive"), _c('div', {
    staticClass: "footer-main__addy-city"
  }, [_vm._v("Boone, NC 28607")])], 1), _c('a', {
    staticClass: "footer-main__phone",
    attrs: {
      "href": "tel:18282640110",
      "title": "Telephone"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "footer-phone",
      "aria-label": "Telephone"
    }
  }), _vm._v("828-264-0110")], 1)])]), _c('div', {
    staticClass: "footer-main__loc"
  }, [_c('div', {
    staticClass: "footer-main__title"
  }, [_vm._v("Wilkesboro Location")]), _c('div', {
    staticClass: "footer-main__info"
  }, [_c('a', {
    staticClass: "footer-main__addy",
    attrs: {
      "href": "",
      "target": "_blank",
      "title": "Footer Address Info"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "footer-pin",
      "aria-label": "Footer Address Info"
    }
  }), _vm._v("1922 West Park Drive"), _c('div', {
    staticClass: "footer-main__addy-city"
  }, [_vm._v("North Wilkesboro, NC 28659")])], 1), _c('a', {
    staticClass: "footer-main__phone",
    attrs: {
      "href": "tel:13366674114",
      "title": "Telephone"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "footer-phone",
      "aria-label": "Telephone"
    }
  }), _vm._v("336-667-4114")], 1)])]), _c('router-link', {
    staticClass: "footer-main__logo",
    attrs: {
      "to": "/",
      "title": "Homepage"
    }
  }, [_c('img', {
    staticClass: "logo_new",
    attrs: {
      "src": "https://www.opsmiles.com/wp-content/uploads/image003.jpg",
      "alt": "logo"
    }
  })]), _c('div', {
    staticClass: "footer-main__login"
  }, [_c('div', {
    staticClass: "footer-main__title"
  }, [_vm._v("Patient Login")]), _c('a', {
    staticClass: "footer-main__orthofi",
    attrs: {
      "href": "https://login.orthofi.com/sign-in",
      "target": "_blank",
      "title": "Login Link"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "footer-user",
      "aria-label": "OrthoFi"
    }
  }), _vm._v("OrthoFi")], 1)]), _c('div', {
    staticClass: "footer-main__login"
  }, [_c('div', {
    staticClass: "footer-main__title"
  }, [_vm._v("Follow Us")]), _c('a', {
    staticClass: "footer-main__sosh",
    attrs: {
      "href": "http://www.facebook.com/pages/Boone-NC/Drs-Mayhew-Scheffler-Conn-and-Hardaway/339815034168?ref=ts",
      "target": "_blank",
      "title": "Facebook Link"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "sosh-fb",
      "aria-label": "Facebook"
    }
  })], 1), _c('a', {
    staticClass: "footer-main__sosh",
    attrs: {
      "href": "https://twitter.com/#!/opsmilesboone",
      "target": "_blank",
      "title": "Twitter Link"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "sosh-twit",
      "aria-label": "Twitter"
    }
  })], 1), _c('a', {
    staticClass: "footer-main__sosh",
    attrs: {
      "href": "https://www.youtube.com/channel/UCKT5GaCQU7onpIV2QOF1AXQ",
      "target": "_blank",
      "title": "Youtube Link"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "sosh-yt",
      "aria-label": "Youtube"
    }
  })], 1), _c('a', {
    staticClass: "footer-main__sosh",
    attrs: {
      "href": "https://www.instagram.com/opsmiles/",
      "target": "_blank",
      "title": "Instagram Link"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "sosh-ig",
      "aria-label": "Instagram"
    }
  })], 1), _vm._m(0), _vm._m(1), _vm._m(2)])], 1), _c('div', {
    staticClass: "footer-main__content-fine"
  }, [_vm._m(3), _c('div', {
    staticClass: "footer-main__rg"
  }, [_vm._v("Online Advantage by"), _c('a', {
    attrs: {
      "href": "http://roostergrin.com/",
      "target": "_blank",
      "title": "Rooster Grin Media"
    }
  }, [_vm._v("Rooster Grin Media"), _c('Icon', {
    attrs: {
      "name": "rg",
      "aria-label": "Rooster Grin Media"
    }
  })], 1), _c('br'), _vm._v("Photography by Burton Photography")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "footer-main__sosh",
    attrs: {
      "href": "https://www.tiktok.com/@op_smiles",
      "target": "_blank",
      "title": "Tiktok Link"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://www.opsmiles.com/wp-content/uploads/dark-titok.png",
      "alt": "dark-titok"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "footer-main__sosh",
    attrs: {
      "href": "https://www.youtube.com/channel/UCKT5GaCQU7onpIV2QOF1AXQ",
      "target": "_blank",
      "title": "Youtube Link"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://www.opsmiles.com/wp-content/uploads/dark-youtube.png",
      "alt": "dark-youtube"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "footer-main__sosh",
    attrs: {
      "href": "https://www.pinterest.com/opsmiles/",
      "target": "_blank",
      "title": "Pinterest Link"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://www.opsmiles.com/wp-content/uploads/pinterest1.png",
      "alt": "dark-pinterest"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-main__cr"
  }, [_vm._v("© 2024 OPSmiles Orthodontists & Pediatric Dentists |"), _c('a', {
    attrs: {
      "href": "https://www.opsmiles.com/wp-content/uploads/NOTICE-OF-PRIVACY-PRACTICES-2024.pdf",
      "title": "Privacy Policy"
    }
  }, [_vm._v("Privacy Policy")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac78d7b4","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/footer/footer.pug
// module id = 652
// module chunks = 1